function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_qr_code_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M127.6 127.6H0V0h127.6v127.6zM28.4 99.2h70.7V28.4H28.4v70.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.6 49.6h28.3v28.3H49.6zM127.6 283.5H0V155.9h127.6v127.6zm-99.2-28.4h70.7v-70.7H28.4v70.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.6 205.5h28.3v28.3H49.6zM283.5 127.6H155.9V0h127.6v127.6zm-99.2-28.4H255V28.4h-70.7v70.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.5 49.6h28.3v28.3h-28.3zM283.5 283.5H155.9V155.9h127.6v127.6zm-99.2-28.4H255v-70.7h-70.7v70.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.5 205.5h28.3v28.3h-28.3z"
})));